import { useCallback, useState } from 'react';

export const useEffectTrigger = (): [unknown, () => void] => {
  const [trigger, setTrigger] = useState({});
  const activateTrigger = useCallback(() => setTrigger({}), []);
  return [trigger, activateTrigger];
};
